import _objectSpread from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementBlock as _createElementBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 查询 ");

const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 重置 ");

const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 添加 ");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("删除");

const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 导出 ");

const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 编辑 ");

const _hoisted_7 = /*#__PURE__*/_createTextVNode("查看");

import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import { exportCarouselList } from '@/request/api';
import { getCarouselConfigureList, delCarouselConfigure, exportForAsync } from '@/request';
import { getVexTableProps } from '@/config';
import { ElMessage, ElMessageBox } from 'element-plus';
import AddCarouselConfigureModal from './component/AddCarouselConfigureModal.vue';
export default {
  name: 'CarouselConfigure',

  setup(__props) {
    const store = useStore();
    store.dispatch('getDictList');
    const dictList = computed(() => store.state.dictList);
    const showAddModal = ref(false);
    const form = ref({
      companyManagerName: '',
      supplierName: '',
      slideshowType: '',
      branchId: []
    });
    const isSee = ref(false);
    const editData = ref(null);
    const table = ref();
    const dataTotal = ref(0);
    const tableOptions = getVexTableProps({
      columns: [{
        type: 'checkbox',
        width: '50px',
        fixed: 'left'
      }, {
        field: 'companyManagerName',
        title: '创建人账号',
        width: '150px',
        showOverflow: true
      }, // {
      //   title: '地区',
      //   field: 'shortName',
      //   width: '250px',
      //   showOverflow: true
      // },
      {
        title: '接收团队',
        field: 'supplierNames',
        width: '250px',
        showOverflow: true,
        formatter: ({
          cellValue
        }) => cellValue || '全部团队'
      }, {
        title: '轮播图',
        slots: {
          default: 'previewImg'
        },
        width: '100px',
        showOverflow: true
      }, {
        title: '轮播图类型',
        field: 'slideshowTypeDes',
        width: '150px',
        showOverflow: true
      }, {
        title: '页面标题',
        field: 'title',
        width: '150px',
        showOverflow: true
      }, {
        title: '排序',
        field: 'sort',
        width: '50px',
        showOverflow: true
      }, {
        title: '跳转链接',
        field: 'link',
        width: '250px',
        showOverflow: true
      }, {
        title: '更新时间',
        field: 'updateAt',
        width: '250px',
        showOverflow: true
      }, {
        title: '操作',
        field: 'operation',
        fixed: 'right',
        width: '100px',
        slots: {
          default: 'operation'
        }
      }],
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      checkboxConfig: {
        checkMethod({
          row
        }) {
          return store.state.user.username === row.companyManagerName;
        }

      },
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getCarouselConfigureList(_objectSpread(_objectSpread({
              page: page.currentPage,
              rows: page.pageSize
            }, form.value), {}, {
              branchId: form.value.branchId.join(',')
            })).then(data => {
              dataTotal.value = data.total;
              data.rows.forEach(i => {
                i.shortName = i.shortName ? i.shortName : '全部';
              });
              res({
                total: data.total,
                result: data.rows
              });
            });
          })
        }
      }
    });

    function reset() {
      form.value = {
        companyManagerName: '',
        supplierName: '',
        slideshowType: '',
        branchId: []
      };
      table.value.commitProxy('reload');
    }

    function edit(row) {
      isSee.value = false;
      showAddModal.value = true;
      editData.value = row;
    }

    function see(row) {
      isSee.value = true;
      showAddModal.value = true;
      editData.value = row;
    }

    function add() {
      isSee.value = false;
      showAddModal.value = true;
      editData.value = null;
    }

    function del() {
      // delCarouselConfigure
      const selectRows = table.value.getCheckboxRecords();

      if (!selectRows.length) {
        ElMessage.warning('请勾选后再进行操作!');
        return;
      }

      ElMessageBox.confirm(`是否确认删除${selectRows.length}条信息?`, '删除').then(() => {
        delCarouselConfigure({
          __warn: true,
          __repeat: true
        }, {
          params: {
            activityIdS: selectRows.map(row => row.supSlideshowConfigId).join(',')
          }
        }).then(data => {
          if (data.success) {
            ElMessage.success('操作成功!');
            table.value.commitProxy('query');
          }
        });
      });
    }

    function addSuccess() {
      table.value.commitProxy('query');
      showAddModal.value = false;
    }

    function exportFile() {
      exportForAsync(_objectSpread(_objectSpread({
        __repeat: true,
        __warn: true
      }, form.value), {}, {
        branchId: form.value.branchId.join(','),
        modularflag: 'slideConfig',
        fileName: '轮播图配置查询',
        count: dataTotal.value,
        methodName: exportCarouselList.url
      }));
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_image = _resolveComponent("el-image");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_form, null, {
        default: _withCtx(() => [_createVNode(_component_el_row, {
          gutter: 20
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "创建人账号"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.companyManagerName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.companyManagerName = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "团队名称"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.supplierName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.supplierName = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        justify: "end"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          icon: "Search",
          onClick: _cache[2] || (_cache[2] = $event => table.value.commitProxy('reload'))
        }, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          icon: "Refresh",
          onClick: reset
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_vxe_grid, _mergeProps({
        ref_key: "table",
        ref: table
      }, _unref(tableOptions)), {
        tools: _withCtx(() => [_createVNode(_component_el_button, {
          icon: "CirclePlus",
          type: "primary",
          onClick: add
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        }), _createVNode(_component_el_button, {
          icon: "Delete",
          type: "danger",
          onClick: del
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        }), _createVNode(_component_el_button, {
          icon: "Download",
          onClick: exportFile
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        })]),
        previewImg: _withCtx(({
          row
        }) => [_createVNode(_component_el_image, {
          style: {
            "width": "70px",
            "height": "70px"
          },
          src: row.slideshowUrl,
          "preview-src-list": [row.slideshowUrl],
          fit: "cover"
        }, null, 8, ["src", "preview-src-list"])]),
        operation: _withCtx(({
          row
        }) => [_unref(store).state.user.username === row.companyManagerName ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          icon: "Edit",
          type: "primary",
          onClick: $event => edit(row)
        }, {
          default: _withCtx(() => [_hoisted_6]),
          _: 2
        }, 1032, ["onClick"])) : (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          type: "success",
          onClick: $event => see(row)
        }, {
          default: _withCtx(() => [_hoisted_7]),
          _: 2
        }, 1032, ["onClick"]))]),
        _: 1
      }, 16), _createVNode(AddCarouselConfigureModal, {
        modelValue: showAddModal.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => showAddModal.value = $event),
        editData: editData.value,
        isSee: isSee.value,
        onSuccess: addSuccess,
        dictList: _unref(dictList)
      }, null, 8, ["modelValue", "editData", "isSee", "dictList"])]);
    };
  }

};